<template>
  <div class="chargingOrderDetails">
    <div class="charging-order-hero">
      <div class="charging-order-hero-main">
        <span class="charging-order-eyebrow">CHARGING ORDER DETAIL</span>
        <h2>充电订单详情</h2>
        <p>查看订单充电过程、费用明细、充电桩与车辆信息。</p>
      </div>
      <div class="charging-order-hero-side">
        <div class="charging-order-summary">
          <div class="charging-order-summary-item">
            <span>订单金额</span>
            <strong>{{ dateDetails.ORMTB607CA06 || 0 + '元' }}</strong>
          </div>
          <div class="charging-order-summary-item">
            <span>充电电量</span>
            <strong>{{ dateDetails.ORMTB607CA07 || 0 }}</strong>
          </div>
          <div class="charging-order-summary-item">
            <span>充电时长</span>
            <strong>{{ dateDetails.ORMTB607CA08 }}</strong>
          </div>
        </div>
        <el-button
          @click="back"
          class="back_btn"
          type="primary"
          icon="el-icon-back"
          >返回上一级</el-button
        >
      </div>
    </div>

    <el-card class="detail-card order-card">
      <div slot="header" class="detail-card-header">
        <span>订单信息</span>
      </div>
      <div class="detail-grid order-grid">
        <div class="detail-item detail-item-primary">
          <span>订单编号</span>
          <strong>{{ dateDetails.ORMTB607CA14 }}</strong>
        </div>
        <div class="detail-item">
          <span>充电开始时间</span>
          <strong>{{ dateDetails.ORMTB607CA02 }}</strong>
        </div>
        <div class="detail-item">
          <span>充电结束时间</span>
          <strong>{{ dateDetails.ORMTB607CA03 }}</strong>
        </div>
        <div class="detail-item" v-if="dateDetails.ORMTB607CA10 != 3">
          <span>充电开始SOC</span>
          <strong>{{ dateDetails.ORMTB607CA16 }}</strong>
        </div>
        <div class="detail-item" v-if="dateDetails.ORMTB607CA10 == 3">
          <span>预约充电时间</span>
          <strong>{{ dateDetails.ORMTB607CA18 }}</strong>
        </div>
        <div class="detail-item" v-if="dateDetails.ORMTB607CA10 != 3">
          <span>充电结束SOC</span>
          <strong>{{ dateDetails.ORMTB607CA13 }}</strong>
        </div>
        <div class="detail-item">
          <span>充电时长</span>
          <strong>{{ dateDetails.ORMTB607CA08 }}</strong>
        </div>
        <div class="detail-item detail-item-energy">
          <span>充电电量</span>
          <strong>{{ dateDetails.ORMTB607CA07 || 0 }}</strong>
        </div>
        <div class="detail-item">
          <span>启动方式</span>
          <strong>{{ dateDetails.ORMTB607CA09 }}</strong>
        </div>
        <div class="detail-item detail-item-money">
          <span>订单金额</span>
          <strong>{{ dateDetails.ORMTB607CA06 || 0 + '元' }}</strong>
        </div>
        <div class="detail-item detail-item-money">
          <span>实付金额</span>
          <strong>{{ dateDetails.ORMTB607CA06 || 0 + '元' }}</strong>
        </div>
        <div class="detail-item detail-item-money">
          <span>电费金额</span>
          <strong>{{ dateDetails.ORMTB607CA06 || 0 + '元' }}</strong>
        </div>
        <div class="detail-item">
          <span>服务费金额</span>
          <strong>0元</strong>
        </div>
        <div class="detail-item detail-item-full">
          <span>结束原因</span>
          <strong>{{ dateDetails.ORMTB607CA04 || '暂无' }}</strong>
        </div>
      </div>
    </el-card>

    <div class="detail-card-row">
      <el-card class="detail-card half-card">
        <div slot="header" class="detail-card-header">
          <span>充电桩信息</span>
        </div>
        <div class="detail-grid single-grid">
          <div class="detail-item">
            <span>充电桩名称</span>
            <strong>{{ dateDetails.ORMTB602CA03 }}</strong>
          </div>
          <div class="detail-item">
            <span>充电桩编号</span>
            <strong>{{ dateDetails.ORMTB602CA00 }}</strong>
          </div>
        </div>
      </el-card>

      <el-card class="detail-card half-card">
        <div slot="header" class="detail-card-header">
          <span>车辆信息</span>
        </div>
        <div class="detail-grid single-grid">
          <div class="detail-item">
            <span>车牌号码</span>
            <strong>{{ dateDetails.ORMTB607CA12 }}</strong>
          </div>
          <div class="detail-item">
            <span>车牌VIN</span>
            <strong>{{ dateDetails.ORMTB607CA11 || '暂无' }}</strong>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dateDetails: {},
    }
  },
  mounted() {
    this.fetchDetail(this.$route.query.id)
  },
  watch: {
    '$route.query.id'(id) {
      this.fetchDetail(id)
    }
  },
  methods: {
    fetchDetail(id) {
      let url = '/orm/ormtb607/ormtb607Detail?ormtb607Id=' + id
      this.axios.get(url).then(res => {
        if (res.data.code == 200) {
          this.dateDetails = res.data.data.ormtb607
        }
      })
    },
    back() {
      this.$router.back()
    },
  },
}
</script>

<style scoped>
.chargingOrderDetails {
  min-height: 100%;
  padding: 18px;
  background:
    radial-gradient(circle at 12% 8%, rgba(25, 159, 255, 0.12) 0, rgba(25, 159, 255, 0) 28%),
    linear-gradient(180deg, #f7fbff 0%, #edf5fb 100%);
  box-sizing: border-box;
  color: #25384d;
}

.charging-order-hero {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 22px;
  margin-bottom: 18px;
  padding: 24px;
  border: 1px solid rgba(188, 222, 236, 0.95);
  border-radius: 22px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.94) 0%, rgba(242, 251, 255, 0.94) 54%, rgba(238, 248, 244, 0.94) 100%);
  box-shadow: 0 16px 42px rgba(26, 99, 134, 0.11);
  box-sizing: border-box;
  overflow: hidden;
}

.charging-order-hero::after {
  content: '';
  position: absolute;
  right: -54px;
  top: -72px;
  width: 210px;
  height: 210px;
  border-radius: 50%;
  background: rgba(25, 159, 255, 0.10);
}

.charging-order-hero-main {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.charging-order-eyebrow {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(25, 159, 255, 0.12);
  color: #1473b3;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.charging-order-hero h2 {
  margin: 0;
  color: #17324d;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 1px;
}

.charging-order-hero p {
  margin: 8px 0 0;
  color: #60758a;
  font-size: 13px;
  line-height: 1.6;
}

.charging-order-hero-side {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
}

.charging-order-summary {
  display: flex;
  gap: 12px;
}

.charging-order-summary-item {
  min-width: 92px;
  padding: 12px 14px;
  border: 1px solid rgba(203, 226, 236, 0.92);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 8px 20px rgba(26, 99, 134, 0.08);
  text-align: center;
  box-sizing: border-box;
}

.charging-order-summary-item span {
  display: block;
  color: #6d8194;
  font-size: 12px;
}

.charging-order-summary-item strong {
  display: block;
  margin-top: 6px;
  color: #1473b3;
  font-size: 18px;
  line-height: 1;
}

.detail-card {
  width: 100%;
  border: 1px solid rgba(216, 232, 238, 0.96);
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 14px 34px rgba(26, 99, 134, 0.09);
  overflow: hidden;
  box-sizing: border-box;
}

.order-card {
  margin-bottom: 18px;
}

::v-deep .detail-card .el-card__header {
  padding: 20px 22px;
  border-bottom: 1px solid rgba(216, 232, 238, 0.95);
  background: linear-gradient(180deg, #ffffff 0%, #f8fcff 100%);
}

::v-deep .detail-card .el-card__body {
  padding: 22px;
}

.detail-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.detail-card-header > span {
  position: relative;
  padding-left: 12px;
  color: #17324d;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 1px;
}

.detail-card-header > span::before {
  content: '';
  position: absolute;
  top: 3px;
  left: 0;
  width: 4px;
  height: 16px;
  border-radius: 999px;
  background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%);
}

.detail-grid {
  display: grid;
  gap: 18px;
}

.order-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.single-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.detail-item {
  position: relative;
  min-height: 86px;
  padding: 18px 20px;
  border: 1px solid rgba(216, 232, 238, 0.95);
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fcff 100%);
  box-shadow: 0 8px 18px rgba(26, 99, 134, 0.05);
  box-sizing: border-box;
  overflow: hidden;
}

.detail-item::after {
  content: '';
  position: absolute;
  right: -26px;
  bottom: -34px;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: rgba(25, 159, 255, 0.06);
}

.detail-item-primary {
  border-color: rgba(25, 159, 255, 0.28);
  background: linear-gradient(135deg, #ffffff 0%, #eef8ff 100%);
}

.detail-item-money {
  border-color: rgba(245, 158, 11, 0.24);
  background: linear-gradient(135deg, #ffffff 0%, #fff8ed 100%);
}

.detail-item-energy {
  border-color: rgba(14, 159, 110, 0.22);
  background: linear-gradient(135deg, #ffffff 0%, #eefbf5 100%);
}

.detail-item-full {
  grid-column: 1 / -1;
}

.detail-item span {
  position: relative;
  z-index: 1;
  display: block;
  margin-bottom: 10px;
  color: #6b7e90;
  font-size: 13px;
  line-height: 1;
}

.detail-item strong {
  position: relative;
  z-index: 1;
  display: block;
  color: #17324d;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  word-break: break-all;
}

.detail-card-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.back_btn {
  flex-shrink: 0;
  float: none;
  border: none;
  border-radius: 999px;
  background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(25, 159, 255, 0.24);
}

.back_btn:hover,
.back_btn:focus {
  background: linear-gradient(180deg, #5bb8ee 0%, #148adf 100%);
  color: #fff;
}

::v-deep .name-header {
  background-color: #e6a23c !important;
}

@media screen and (max-width: 1100px) {
  .charging-order-hero {
    align-items: flex-start;
    flex-direction: column;
  }

  .charging-order-hero-side {
    align-items: flex-start;
    width: 100%;
  }

  .charging-order-summary {
    flex-wrap: wrap;
  }

  .order-grid,
  .single-grid,
  .detail-card-row {
    grid-template-columns: 1fr;
  }
}
</style>
